(() => {
  const initOne = (component) => {
    if (!component || component.dataset.yumoraRotateReady === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    const nextButton = component.querySelector('button[name="next"]');
    const slides = component.querySelectorAll('[id^="Slide-"]');

    if (!slider || !nextButton || slides.length < 2) return;

    component.dataset.yumoraRotateReady = 'true';
    const speed = Math.max(3000, (Number(slider.dataset.speed) || 4) * 1000);

    const timer = window.setInterval(() => {
      if (!document.documentElement.contains(component)) {
        window.clearInterval(timer);
        return;
      }
      nextButton.click();
    }, speed);
  };

  const init = (root = document) => {
    if (root.matches?.('slideshow-component.announcement-bar')) initOne(root);
    root.querySelectorAll?.('slideshow-component.announcement-bar').forEach(initOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
